<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="$vuetify.lang.t('$vuetify.DASHBOARD.USERS')"
      :breadcrumbs="[
        {
          text: $vuetify.lang.t('$vuetify.DASHBOARD.USERS_DESCRIPTION'),
          disabled: true
        }
      ]"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" class="row d-flex align-center">
        <v-card
          :class="users.length ? 'elevation-3' : 'elevation-3'"
          style="width: 100%"
        >
          <v-card-text>
            <div class="row col d-inline-flex align-center">
              <searchbar
                :placeholder-text="
                  $vuetify.lang.t('$vuetify.SEARCH_BY_NAME_OR_EMAIL')
                "
                :slot-cols="'4'"
                @on-search="onPageSizeChange"
              >
                <v-text-field
                  v-model="additionalSearchString"
                  class="mb-4"
                  hide-details
                  :label="
                    $vuetify.lang.t(
                      '$vuetify.SEARCH_BY_PLACE_FLEET_OR_WHITELIST_NAME'
                    )
                  "
                  aria-label="Search"
                  append-icon="mdi-magnify"
                  @input="searchDidChange"
                  @keyup.enter="onPageSizeChange"
                >
                  <v-icon slot="append" @click="onPageSizeChange"
                    >mdi-magnify</v-icon
                  >
                </v-text-field>
              </searchbar>
              <v-btn color="success" text small @click="openEditOwnerDialog()">
                <v-icon class="mr-2">mdi-plus</v-icon>
                {{ $vuetify.lang.t('$vuetify.ADD_NEW_USER') }}
              </v-btn>
            </div>
            <!-- <div class="d-flex align-center col">
                <v-text-field
                  v-model="additionalSearchString"
                  class="mb-4"
                  hide-details
                  :label="'Otsi asukoha või kasutajaload järgi'"
                  aria-label="Search"
                  append-icon="mdi-magnify"
                  @input="searchDidChange"
                  @keyup.enter="onPageSizeChange"
                >
                  <v-icon slot="append" @click="onPageSizeChange"
                    >mdi-magnify</v-icon
                  >
                </v-text-field>
              </div> -->

            <v-data-table
              v-if="users.length"
              class="overflow-y-auto rounded-lg"
              style="max-height: 60vh;"
              :items="users"
              :items-per-page="pageSize"
              :headers="computedHeaders"
              hide-default-footer
            >
              <template v-if="isGlobalAdmin" v-slot:item.Comments="props">
                <td v-if="props.item.Comments.length">
                  {{ props.item.Comments }}
                </td>
                <td v-else>
                  -
                </td>
              </template>
              <template v-if="isGlobalAdmin" v-slot:item.Admin="props">
                <td>
                  <v-icon v-if="props.item.Admin" small color="success">
                    mdi-check
                  </v-icon>
                </td>
              </template>
              <template v-if="isGlobalAdmin" v-slot:item.Region="props">
                <td v-if="props.item.Region.length">
                  {{ props.item.Region }}
                </td>
                <td v-else>
                  -
                </td>
              </template>
              <template v-if="isGlobalAdmin" v-slot:item.Zones="props">
                <td v-if="props.item.Zones.length">
                  {{ props.item.Zones }}
                </td>
                <td v-else>
                  -
                </td>
              </template>
              <!-- <template
                v-if="isGlobalAdmin"
                v-slot:item.CanSeeClientsPersonalData="props"
              >
                <td>
                  <v-icon
                    v-if="props.item.CanSeeClientsPersonalData"
                    small
                    color="success"
                  >
                    mdi-check
                  </v-icon>
                  <v-icon v-else small color="error">
                    mdi-close
                  </v-icon>
                </td>
              </template> -->
              <template v-slot:item.Verified="props">
                <td>
                  <v-icon v-if="props.item.Verified" small color="success">
                    mdi-check
                  </v-icon>
                </td>
              </template>
              <template v-if="isGlobalAdmin" v-slot:item.Places="props">
                <td>
                  {{
                    props.item.Places
                      ? props.item.Places.map(item => {
                          return item.Name
                        }).join(',')
                      : '-'
                  }}
                </td>
              </template>
              <template v-slot:item.actions="props">
                <td>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        class="mr-2 secondary--text"
                        @click="openEditOwnerDialog(props.item)"
                        v-on="on"
                      >
                        <v-icon small>
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $vuetify.lang.t('$vuetify.EDIT_USER_SLASH_COMPANY') }}
                    </span>
                  </v-tooltip>
                </td>
                <td>
                  <v-menu offset-y dense>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item
                        v-if="isGlobalAdmin && props.item.Verified"
                        @click="loginAs(props.item.Email)"
                      >
                        <v-list-item-title>
                          <v-icon small class="mr-2">mdi-eye-outline</v-icon>
                          {{ $vuetify.lang.t('$vuetify.LOGIN_AS_THIS_USER') }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="inviteOwnerInternal(props.item)">
                        <v-list-item-title>
                          <v-icon small class="mr-2">mdi-send</v-icon>
                          {{ $vuetify.lang.t('$vuetify.SEND_OWNER_INVITE') }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="resetPassword(props.item)">
                        <v-list-item-title>
                          <v-icon small class="mr-2">mdi-lock-reset</v-icon>
                          {{ $vuetify.lang.t('$vuetify.RESET_PASSWORD') }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="
                          (props.item.PasswordResetLinkUuid &&
                            props.PasswordResetLinkUuid !== '' &&
                            isPasswordResetLinkValid(props.item)) ||
                            (props.item.PasswordResetLink &&
                              props.item.PasswordResetLink !== '')
                        "
                        @click="copyPasswordResetLink(props.item)"
                      >
                        <v-list-item-title>
                          <v-icon small class="mr-2">mdi-clipboard</v-icon>
                          {{
                            $vuetify.lang.t('$vuetify.COPY_PASSWORD_RESET_LINK')
                          }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="removeUser(props.item)">
                        <v-list-item-title>
                          <v-icon small color="error" class="mr-2">
                            mdi-delete
                          </v-icon>
                          {{ $vuetify.lang.t('$vuetify.DELETE') }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </template>
            </v-data-table>
            <v-toolbar
              v-else-if="loading.state && loading.type === 'getUsers'"
              class="elevation-0 mt-12"
            >
              <v-spacer></v-spacer>
              <v-progress-circular
                indeterminate
                color="secondary"
              ></v-progress-circular>
              <v-spacer></v-spacer>
            </v-toolbar>
            <empty-state-card
              v-if="!users.length && !loading.state && loading.type === ''"
              :title="$vuetify.lang.t('$vuetify.EMPTY_STATE.USERS_EMPTY_HERE')"
              color="transparent"
              :message="
                $vuetify.lang.t('$vuetify.EMPTY_STATE.USERS_EMPTY_HERE_MESSAGE')
              "
              class="empty-state"
            />
          </v-card-text>
          <v-toolbar color="transparent" class="elevation-0">
            <v-spacer></v-spacer>
            <v-btn
              fab
              color="white"
              x-small
              class="ma-2"
              :disabled="currentPageNumber === 0"
              @click="prevPage()"
            >
              <v-icon color="rgba(0, 0, 0, 0.54)">mdi-menu-left</v-icon>
            </v-btn>
            <v-btn fab color="primary" class="secondary--text" x-small readonly>
              {{ currentPageNumber + 1 }}
            </v-btn>
            <v-btn
              fab
              color="white"
              x-small
              class="ma-2"
              :disabled="!nextAvailablePage || nextAvailablePage <= 0"
              @click="nextPage()"
            >
              <v-icon color="rgba(0, 0, 0, 0.54)">mdi-menu-right</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-col cols="1" class="pa-0">
              <v-select
                v-model="pageSize"
                :items="[10, 30, 50, 100, 250, 500, 1000, 1500]"
                :label="$vuetify.lang.t('$vuetify.STATISTICS.SHOW')"
                hide-details
                @change="onPageSizeChange"
              ></v-select>
            </v-col>
          </v-toolbar>
        </v-card>
      </v-col>
    </v-row>
    <edit-owner-dialog
      v-if="selectedOwner"
      :owner="selectedOwner"
      :visible="editOwnerDialog"
      @close="
        editOwnerDialog = false
        selectedOwner = null
      "
    />
  </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Owner from '@/models/owner'
import { EventBus } from '@/event-bus.js'
import { landingForUser } from '@/utils/landing'

export default {
  name: 'Users',
  components: {
    Searchbar: () =>
      import(/* webpackChunkName: "Searchbar" */ '@/components/Searchbar'),
    EditOwnerDialog: () =>
      import(
        /* webpackChunkName: "EditOwnerDialog" */ '@/components/EditOwnerDialog'
      ),
    EmptyStateCard: () =>
      import(
        /* webpackChunkName: "EmptyStateCard" */ '@/components/commonComponents/EmptyStateCard'
      )
  },
  props: {
    id: String
  },
  data: () => ({
    elementVisible: false,
    editOwnerDialog: false,
    selectedOwner: null,
    additionalSearchString: ''
  }),
  computed: {
    ...mapGetters('app', ['searchString', 'loading']),
    ...mapGetters('users', ['users', 'filteredUsers', 'nextAvailablePage']),
    ...mapGetters('authentication', ['user', 'isGlobalAdmin']),
    computedHeaders() {
      const headers = [
        {
          text: this.$vuetify.lang.t('$vuetify.NAME'),
          align: 'left',
          sortable: false,
          value: 'Name'
        },
        {
          text: this.$vuetify.lang.t('$vuetify.COMMENTS'),
          sortable: false,
          value: 'Comments',
          guarded: true
        },
        {
          text: this.$vuetify.lang.t('$vuetify.PHONE_NUMBER'),
          sortable: false,
          value: 'PhoneNumber'
        },
        {
          text: 'Email',
          sortable: false,
          value: 'Email'
        },
        {
          text: 'Superadmin',
          sortable: false,
          value: 'Admin',
          guarded: true
        },
        {
          text: this.$vuetify.lang.t('$vuetify.REGION'),
          sortable: false,
          value: 'Region',
          guarded: true
        },
        {
          text: this.$vuetify.lang.t('$vuetify.ZONES'),
          sortable: false,
          value: 'Zones',
          guarded: true
        },
        // {
        //   text: 'Sees clients data',
        //   sortable: false,
        //   value: 'CanSeeClientsPersonalData',
        //   guarded: true
        // },
        {
          text: this.$vuetify.lang.t('$vuetify.VERIFIED'),
          sortable: false,
          value: 'Verified'
        },
        {
          text: this.$vuetify.lang.t('$vuetify.LOCATIONS'),
          sortable: false,
          value: 'Places',
          guarded: true
        },
        {
          text: '',
          sortable: false,
          value: 'actions'
        }
      ]
      return headers.filter(col => {
        if (col.guarded) {
          return this.isGlobalAdmin
        }
        return col
      })
    },
    filteredData() {
      if (this.searchString.length) {
        return this.filteredUsers
      }
      return this.users
    },
    currentPageNumber: {
      get() {
        return this.$store.state.users.currentPageNumber
      },
      set(val) {
        this.setCurrentPageNumber(val)
      }
    },
    pageSize: {
      get() {
        return this.$store.state.users.pageSize
      },
      set(val) {
        this.setPageSize(val)
      }
    }
  },
  created() {
    EventBus.$on('onSearchButtonClick', () => {
      this.onPageSizeChange()
    })
    if (!this.users.length) {
      this.$store.dispatch('users/getUsersV2', {
        page: this.currentPageNumber,
        pageSize: this.pageSize,
        name: this.searchString,
        whitelistFleetPlaceSearchString: this.additionalSearchString
      })
    }
  },
  methods: {
    ...mapMutations('app', ['setSearchString']),
    ...mapMutations('users', ['setCurrentPageNumber', 'setPageSize']),
    ...mapActions('authentication', ['resetPassword']),
    ...mapActions('users', ['inviteOwner', 'deleteUser']),
    searchDidChange(val) {
      this.setSearchString(val)
    },
    async loginAs(email) {
      const uuid = await this.$store.dispatch(
        'authentication/createMagicLink',
        email
      )
      if (uuid) {
        await this.$store
          .dispatch('authentication/login', { magicLinkUuid: uuid })
          .then(() => {
            const target = landingForUser(this.user)
            if (target.external) {
              window.location.replace(target.path)
              return
            }
            this.$router.replace(target.path)
            window.location.reload()
          })
      }
    },
    openEditOwnerDialog(owner) {
      if (owner) {
        this.selectedOwner = owner
      } else {
        this.selectedOwner = new Owner().getObject()
      }
      this.editOwnerDialog = true
    },
    removeUser(user) {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(option => {
        if (option === true) {
          this.deleteUser(user)
        }
      })
    },
    copyToClipboard(value) {
      const tempTextarea = document.createElement('textarea')

      tempTextarea.value = value
      document.body.appendChild(tempTextarea)
      tempTextarea.select()

      try {
        navigator.clipboard.writeText(tempTextarea.value)
        this.$store.commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'success',
            message: 'Link copied to clipboard'
          },
          { root: true }
        )
      } catch (err) {
        this.$store.commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'error',
            message: 'Failed to copy password reset link'
          },
          { root: true }
        )
      }

      document.body.removeChild(tempTextarea)
    },
    copyPasswordResetLink(user) {
      if (!user) return

      if (
        user.PasswordResetLinkUuid &&
        user.PasswordResetLinkUuid !== '' &&
        this.isPasswordResetLinkValid(user)
      ) {
        this.copyToClipboard(
          `https://dashboard.snabb.xyz/reset/${user.PasswordResetLinkUuid}`
        )
      } else {
        if (!user.PasswordResetLink && !user.PasswordResetLink.length <= 0) {
          return
        }
        this.copyToClipboard(user.PasswordResetLink)
      }
    },
    isPasswordResetLinkValid(user) {
      const date = new Date(user.PasswordLinkRequestValidUntil)
      const now = new Date()
      if (date < now) {
        return false
      }
      return true
    },
    inviteOwnerInternal(owner) {
      this.inviteOwner(owner)
    },
    prevPage() {
      if (this.users.length > 0) {
        this.currentPageNumber -= 1
        this.$store.dispatch('users/getUsersV2', {
          page: this.currentPageNumber,
          pageSize: this.pageSize,
          name: this.searchString,
          whitelistFleetPlaceSearchString: this.additionalSearchString
        })
      }
    },
    nextPage() {
      if (this.users.length !== 0) {
        this.currentPageNumber += 1
        this.$store.dispatch('users/getUsersV2', {
          page: this.currentPageNumber,
          pageSize: this.pageSize,
          name: this.searchString,
          whitelistFleetPlaceSearchString: this.additionalSearchString
        })
      }
    },
    onPageSizeChange() {
      this.setCurrentPageNumber(0)
      this.$store.dispatch('users/getUsersV2', {
        page: this.currentPageNumber,
        pageSize: this.pageSize,
        name: this.searchString,
        whitelistFleetPlaceSearchString: this.additionalSearchString
      })
    }
  }
}
</script>
